export enum RefundType {
  Full = 'FULL',
  Partial = 'PARTIAL',
}
